// State ======================
import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  latest_fetch: '',
  type: 'omsettings',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  effectedByYear: false,
  yearFields: [],
  aliasField: 'year',
  filterOverrides: [],
  relations: [],
  all: {},
  reference: {},
  active: false,
  omOfYear: false,
  modelLabels: {
    single: 'OM Setting',
    plural: 'OM Settings'
  },
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: 'year',
    page: 1,
    sortDesc: []
  },
  print_path: '',
  search: null,
  total: 0,
  print: false,
  export: false,
  bound: {},
  searchFields: ['year'],
  filter: {},
  quickFilters: [],
  include: '',
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations,
  SET_OM_OF_YEAR (state, om) {
    state.omOfYear = om
  }
}

// Actions ====================

export const actions = {
  ...globalActions,
  async set_om_of_year ({ commit, state, getters, dispatch, rootState }, om) {
    await commit('SET_OM_OF_YEAR', om)
  },
  // omOfYear is a boot-time snapshot (layouts/default.vue checkOMSettings) that
  // other pages rely on being available immediately. Never clear it here — only
  // re-derive it after an edit so the snapshot can't lag the saved settings.
  async update (context, payload) {
    const results = await globalActions.update.call(this, context, payload)
    await refreshOmOfYear(context)
    return results
  },
  async create (context, payload) {
    const results = await globalActions.create.call(this, context, payload)
    await refreshOmOfYear(context)
    return results
  }
}

async function refreshOmOfYear ({ state, rootState, dispatch }) {
  const currentYear = rootState.system.waterYear
  const om = Object.values(state.all || {}).find(item => item.year === currentYear)
  if (om) {
    await dispatch('set_om_of_year', om)
  }
}

// Getters ====================

export const getters = {
  ...globalGetters
}
